import * as React from "react";
import { style } from "typestyle";
import { ThunkAction } from "redux-thunk";
import { IStoreState } from "../../redux/rootReducer";
import { IGcpAppDispatch, IExtraArgument } from "../../redux/store";
import { AnyAction } from "redux";
import toPlainError, { IPlainError } from "../../error/toPlainError";
import { connect } from "react-redux";
import AlignCenter from "./AlignCenter";

interface ILoaderProps {
  asyncAction: () => ThunkAction<
    Promise<any>,
    IStoreState,
    IExtraArgument,
    AnyAction
  >;
  dispatch: IGcpAppDispatch;
  children: (asyncActionResult: any) => React.JSX.Element[] | React.JSX.Element;
}
interface ILoaderState {
  pending: boolean;
  error: IPlainError;
  asyncActionResult?: any;
}
class Loader extends React.Component<ILoaderProps, ILoaderState> {
  public state: ILoaderState = {
    pending: true, // set it in advance in order to prevent false children rendering on first mount
    error: null,
  };

  public componentDidMount() {
    const { dispatch, asyncAction } = this.props;
    dispatch(asyncAction()).then(
      (asyncActionResult) => {
        this.setState({
          pending: false,
          error: null,
          asyncActionResult,
        });
      },
      (error) => {
        this.setState({
          pending: false,
          error: toPlainError(error),
        });
      },
    );
  }

  public render() {
    const { children } = this.props;
    const { error, pending } = this.state;

    if (pending) {
      return (
        <AlignCenter>
          <img
            src="throbber.gif"
            className={style({ width: "80px", height: "60px" })}
          />
        </AlignCenter>
      );
    }

    if (error) {
      return (
        <AlignCenter>
          <div>{error.code}</div>
          <div>{error.message}</div>
        </AlignCenter>
      );
    }

    return children(this.state.asyncActionResult);
  }
}

export default connect()(Loader);
